angular.module("events")

    .controller("GuestNotesModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'event_guest_notes', 'event_guest_id', function (LoginService, $scope, $uibModalInstance, event_guest_notes, event_guest_id) {

         //Comprobamos si tiene permiso escritura
         $scope.allowWrite = true;

            if (angular.isUndefined(event_guest_notes)) {
             $scope.guestNotes = {};
             $scope.guestNotes.is_new = true;
                $scope.guestNotes.id = null;
                $scope.guestNotes.name_created = LoginService.get("userName");
         } else {
                $scope.guestNotes = event_guest_notes;
             $scope.guestNotes.is_new = false;
         }
 /*
  * Lo quito para no tener que tratar con html en el listado... es un textarea normal y corriente.
         var font_size = (window as any).CONFIG_TINYMCE["no_company_id"].font_size;
         var font_family = (window as any).CONFIG_TINYMCE["no_company_id"].font_family;
         if (typeof  ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")]) !== 'undefined') {
             if (typeof  ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_size) !== 'undefined') {
                 font_size = (window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_size;
             }
             if (typeof  ((window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_family) !== 'undefined') {
                 font_family = (window as any).CONFIG_TINYMCE["company_id_" + LoginService.get("companyId")].font_family;
             }
         }
        $scope.tinymceDescriptionOptions = {
             resize: true,
             forced_root_block: 'div',
             //min_height: 60,
             //height: 60,
             schema: "html5",
             formats: {
                 bold: { inline: 'b' },
                 underline: { inline: 'u' },
                 italic: { inline: 'i' },
                 alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "left" } },
                 aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "center" } },
                 alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "right" } },
                 alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "justify" } },
             },
             invalid_elements: 'strong,em',
             fontsize_formats: "8px 10px 12px 14px 15px 16px 18px 20px 22px 24px 25px 28px 30px 36px ",
             font_formats: 'Arial=Arial;Cambria=Cambria;Courier New=Courier New;Segoe Script=Segoe Script;Tahoma=Tahoma;Verdana=Verdana',
             body_class: 'custom_tinymce_content',
             language: $translate.use().toLowerCase(), //Hay que customizarlo dependiendo del idioma...
             plugins: 'textcolor paste',
             toolbar: "undo redo |  fontsizeselect bold underline italic | forecolor fontselect | alignleft aligncenter alignright alignjustify",
             menubar: false,
             forced_root_block_attrs: {
                 'style': 'font-family: ' + font_family + '; font-size: ' + font_size
             }
         }*/
         $scope.saveGuestNotes = function () {
             if (angular.isUndefined($scope.guestNotes.event_guest_id)) {
                 $scope.guestNotes.event_guest_id = event_guest_id;
             }
             if ($scope.guestNotes.id == null) {
                 $scope.guestNotes.created_at = new Date();
             }

             $uibModalInstance.close($scope.guestNotes);
         }

         $scope.onCancel = function () {
             $uibModalInstance.dismiss('cancel');
         };

     }])